/* eslint-disable import/prefer-default-export */
export const SET_TRACKING_READY = 'SET_TRACKING_READY';
export const SET_LOAD_TIME = 'SET_LOAD_TIME';
